export const PagesTheme = {
  BUYER: 'buyer',
  FOCUSED: 'focused',
  MARKETING: 'marketing',
  PARTNERSHIP: 'partnership',
} as const;
export type PagesTheme = (typeof PagesTheme)[keyof typeof PagesTheme];

export interface HeaderSettings {
  theme?: PagesTheme;
}
